import { Dispatch, SetStateAction, useEffect, useState } from "react";

export function useStateWithDependency<TValue>(defaultValue: TValue): [TValue, Dispatch<SetStateAction<TValue>>] {
	const [value, setValue] = useState(defaultValue);

	useEffect(() => {
		setValue(defaultValue);
	}, [defaultValue]);

	return [value, setValue];
}
